import { NumberUtils } from "neo-common";
import { Communication } from "neo-games";
import { RouletteActions } from "../Channels/Common/Actions/RouletteActions";

export class StatisticsManager {
    //******************************************************************************************************************
    //  VARIABLES
    //******************************************************************************************************************

    private static HitMapElements: { [key: string]: Array<Object> } = {};

    private static HitMapColors: Array<string> = [];

    private static statisticsEnabled: boolean = false;

    //******************************************************************************************************************
    //  INIT
    //******************************************************************************************************************

    public static initialize(): void {
        // StatisticsManager.HitMapColors = StatisticsManager.createHitMapColors(['0161fe', "ffef00", "ff0000"], 101);
        StatisticsManager.HitMapColors = StatisticsManager.createHitMapColors(["0000b9", "e01d1d"], 101);
        // StatisticsManager.HitMapColors = StatisticsManager.createHitMapColors(['0000b9', "ff7500"], 101);
        // StatisticsManager.HitMapColors = StatisticsManager.createHitMapColors(['000080', "0000d2", "0012ff", "005bff", "00a4ff", '06edf1', "41ffb6", "7bff7b", "b6ff41", "f1fc06", 'ffb900', "ff7500", "ff3200", "d20000", "800000"], 101);
        // StatisticsManager.HitMapColors = StatisticsManager.createHitMapColors(['0161fe', "ffef00"], 101);
    }

    //******************************************************************************************************************
    //  FUNCTIONS
    //******************************************************************************************************************

    private static createHitMapColors(colors: Array<string>, length: number): Array<string> {
        let interpolatedColorArray: Array<string> = [];

        if (colors != null && colors.length > 1) {
            let baseSteps = length / (colors.length - 1);

            for (let i = 0; i < colors.length - 1; i++) {
                let tempColorArray: Array<string> = [];
                let steps = i > 0 ? baseSteps + 1 : baseSteps;
                let stepFactor = 1 / (steps - 1);
                for (let j = 0; j < steps; j++) {
                    tempColorArray.push(StatisticsManager.interpolateColor(colors[i], colors[i + 1], stepFactor * j));
                }

                if (i > 0) {
                    tempColorArray.shift();
                }

                interpolatedColorArray = interpolatedColorArray.concat(tempColorArray);
            }
        }
        return interpolatedColorArray;
    }

    public static updateHitMapElements(serverStatistics: Communication.Game.IRouletteStatistics): void {
        let statistics = serverStatistics;
        if (serverStatistics == null) {
            statistics = StatisticsManager.createInitStatistics();
        }

        let min = statistics.numberStatistics[0].frequencyPercentage;
        let max = statistics.numberStatistics[0].frequencyPercentage;
        let groups = [0, 0, 0, 0, 0, 0]; //columns, dozens

        for (let i = 0; i < statistics.numberStatistics.length; i++) {
            groups = StatisticsManager.getGroupsCount(
                groups,
                statistics.numberStatistics[i].number,
                statistics.numberStatistics[i].frequency,
            );

            if (statistics.numberStatistics[i].frequencyPercentage < min) {
                min = statistics.numberStatistics[i].frequencyPercentage;
            }
            if (statistics.numberStatistics[i].frequencyPercentage > max) {
                max = statistics.numberStatistics[i].frequencyPercentage;
            }
        }

        for (let i = 0; i < statistics.numberStatistics.length; i++) {
            let elements = StatisticsManager.HitMapElements["N_" + statistics.numberStatistics[i].number];
            let colorIndex =
                max - min == 0
                    ? 0
                    : Math.round(((statistics.numberStatistics[i].frequencyPercentage - min) / (max - min)) * 100);
            let color = StatisticsManager.HitMapColors[colorIndex];

            for (let j = 0; j < elements.length; j++) {
                if (elements[j] != null) {
                    let element = (elements[j] as any).getChildElementByName("HeatMap");

                    if (element != null) {
                        let childs = element["childs"];

                        if (childs["HeatMapBg"] != null) {
                            childs["HeatMapBg"]["tint"] = parseInt(color, 16);
                        }

                        if (childs["HeatMapText"] != null) {
                            (childs["HeatMapText"] as any).bitmapText.text =
                                statistics.numberStatistics[i].frequencyPercentage.toFixed(2) + "%";
                            (childs["HeatMapText"] as any).realign();
                        }
                    }
                }
            }
        }

        const pairedTypes = ["low", "even", "red", "black", "odd", "high"];
        for (let i: number = 0; i < pairedTypes.length; i++) {
            const index = i < 3 ? 0 : 1;
            const types = [
                RouletteActions.ActionBetLowOrHigh,
                RouletteActions.ActionBetEvenOrOdd,
                RouletteActions.ActionBetRedOrBlack,
                RouletteActions.ActionBetRedOrBlack,
                RouletteActions.ActionBetEvenOrOdd,
                RouletteActions.ActionBetLowOrHigh,
            ];

            const element = StatisticsManager.HitMapElements[types[i] + index];

            if (element != null) {
                const heatMap = (element[0] as any).getChildElementByName("HeatMap");

                if (heatMap != null) {
                    let childs = heatMap["childs"];

                    if (childs != null && childs["HeatMapText"] != null) {
                        (childs["HeatMapText"] as any).bitmapText.text =
                            parseFloat(statistics[pairedTypes[i]]).toFixed(2) + "%";

                        (childs["HeatMapText"] as any).realign();
                    }
                }
            }
        }

        // ToDo - update IRouletteStatistics interface in Neo.Games
        const trackTypes = ["tiers", "orphelins", "voisins", "zeroGame"];
        for (let i: number = 0; i < trackTypes.length; i++) {
            const element = StatisticsManager.HitMapElements["R_" + trackTypes[i]];
            if (element != null) {
                const heatMap = (element[0] as any).getChildElementByName("HeatMap");

                if (heatMap != null) {
                    let childs = heatMap["childs"];
                    if (childs != null && childs["HeatMapText"] != null) {
                        let hitVal: number =
                            typeof statistics[trackTypes[i]] == "number" ? statistics[trackTypes[i]] : 0;
                        (childs["HeatMapText"] as any).bitmapText.text = hitVal.toFixed(2) + "%";
                        (childs["HeatMapText"] as any).realign();
                    }
                }
            }
        }

        const groupTypes = ["C_0", "C_1", "C_2", "D_0", "D_1", "D_2"];
        for (let i: number = 0; i < groupTypes.length; i++) {
            const element = StatisticsManager.HitMapElements[groupTypes[i]];

            if (element != null) {
                const heatMap = (element[0] as any).getChildElementByName("HeatMap");

                if (heatMap != null) {
                    let childs = heatMap["childs"];

                    if (childs != null && childs["HeatMapText"] != null) {
                        const value =
                            statistics.numbersHistoryCount == null
                                ? "0.00"
                                : parseFloat(
                                      NumberUtils.multiply(
                                          NumberUtils.devide(groups[i], statistics.numbersHistoryCount),
                                          100,
                                      ),
                                  ).toFixed(2);
                        (childs["HeatMapText"] as any).bitmapText.text = value + "%";
                        (childs["HeatMapText"] as any).realign();
                    }
                }
            }
        }
    }

    //******************************************************************************************************************
    //  HANDLERS
    //******************************************************************************************************************

    public static updateData(): void {
        //ToDo
    }

    public static addHitMapElement(index: string, element: Object): void {
        if (StatisticsManager.HitMapElements[index] != null) {
            StatisticsManager.HitMapElements[index].push(element);
        } else {
            StatisticsManager.HitMapElements[index] = [element];
        }
    }

    public static toggleStatistics(): void {
        StatisticsManager.statisticsEnabled = !StatisticsManager.statisticsEnabled;

        StatisticsManager.updateBodyClass();

        for (let key in StatisticsManager.HitMapElements) {
            let elements = StatisticsManager.HitMapElements[key];

            for (let i = 0; i < elements.length; i++) {
                let currentCase = (elements[i] as any).getCurrentCase();

                (elements[i] as any).goToCase(StatisticsManager.statisticsEnabled ? "STATISTICS_ON" : "STATISTICS_OFF");
                (elements[i] as any).goToCase(currentCase);
            }
        }
    }

    public static setEnabled(enabled: boolean): void {
        for (let key in StatisticsManager.HitMapElements) {
            let elements = StatisticsManager.HitMapElements[key];

            for (let i = 0; i < elements.length; i++) {
                StatisticsManager.statisticsEnabled = enabled;
                let currentCase = (elements[i] as any).getCurrentCase();

                (elements[i] as any).goToCase(enabled ? "STATISTICS_ON" : "STATISTICS_OFF");
                (elements[i] as any).goToCase(currentCase);
            }
        }

        StatisticsManager.updateBodyClass();
    }

    public static onLayoutChanged(): void {
        for (let key in StatisticsManager.HitMapElements) {
            let elements = StatisticsManager.HitMapElements[key];

            for (let i = 0; i < elements.length; i++) {
                let currentCase = (elements[i] as any).getCurrentCase();
                (elements[i] as any).goToCase(StatisticsManager.statisticsEnabled ? "STATISTICS_ON" : "STATISTICS_OFF");
                (elements[i] as any).goToCase(currentCase);
            }
        }
    }

    //******************************************************************************************************************
    //  HELPER
    //******************************************************************************************************************

    private static interpolateColor(color1: string, color2: string, factor: number = 0.5): string {
        let rgb1 = StatisticsManager.HexToRgb(color1);
        let rgb2 = StatisticsManager.HexToRgb(color2);
        let colorResult: Array<number> = rgb1.slice();

        for (let i = 0; i < 3; i++) {
            colorResult[i] = Math.round(colorResult[i] + factor * (rgb2[i] - rgb1[i]));
        }

        return StatisticsManager.RgbToHex(colorResult);
    }

    private static RgbToHex(color: Array<number>): string {
        return ((1 << 24) + (color[0] << 16) + (color[1] << 8) + color[2]).toString(16).slice(1);
    }

    private static HexToRgb(color: string): Array<number> {
        let hexColorArray1 = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(color);
        let result: Array<number> = [];

        for (let i = 0; i < 3; i++) {
            result.push(parseInt(hexColorArray1[i + 1], 16));
        }

        return result;
    }

    private static getGroupsCount(currentCounts: Array<number>, number: number, count: number): Array<number> {
        if (number > 0) {
            //column
            if (number % 3 == 1) {
                currentCounts[0] += count;
            } else if (number % 3 == 2) {
                currentCounts[1] += count;
            } else {
                currentCounts[2] += count;
            }

            //dozen
            if (number < 13) {
                currentCounts[3] += count;
            } else if (number < 25) {
                currentCounts[4] += count;
            } else {
                currentCounts[5] += count;
            }
        }

        return currentCounts;
    }

    private static updateBodyClass(): void {
        if (StatisticsManager.statisticsEnabled) {
            document.body.classList.add("statistics-on");
        } else {
            document.body.classList.remove("statistics-on");
        }
    }

    private static createInitStatistics(): Communication.Game.IRouletteStatistics {
        const result = {} as Communication.Game.IRouletteStatistics;
        result.numberStatistics = [];
        result.even = 0;
        result.odd = 0;
        result.red = 0;
        result.black = 0;
        result.high = 0;
        result.low = 0;

        for (let i = 0; i < 37; i++) {
            result.numberStatistics.push({ number: i, frequency: 0, frequencyPercentage: 0 });
        }

        return result;
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/Managers/StatisticsManager.ts
 **/